var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_48001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9995 0H16.4995C16.168 0 15.85 0.131696 15.6156 0.366117C15.3812 0.600537 15.2495 0.918479 15.2495 1.25C15.2495 1.58152 15.3812 1.89946 15.6156 2.13388C15.85 2.3683 16.168 2.5 16.4995 2.5H17.7495V17.5H16.4995C16.168 17.5 15.85 17.6317 15.6156 17.8661C15.3812 18.1005 15.2495 18.4185 15.2495 18.75C15.2495 19.0815 15.3812 19.3995 15.6156 19.6339C15.85 19.8683 16.168 20 16.4995 20H18.9995C19.331 20 19.649 19.8683 19.8834 19.6339C20.1178 19.3995 20.2495 19.0815 20.2495 18.75V1.25C20.2495 0.918479 20.1178 0.600537 19.8834 0.366117C19.649 0.131696 19.331 0 18.9995 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.25049C9.80109 3.98528 9.50496 3.80994 9.17678 3.76306C8.84859 3.71617 8.51522 3.80158 8.25 4.00049C7.98478 4.19941 7.80945 4.49553 7.76256 4.82372C7.71568 5.15191 7.80109 5.48528 8 5.75049L10.25 8.75049H0.25C-0.0815206 8.75049 -0.399463 8.88219 -0.633884 9.11661C-0.868304 9.35103 -1 9.66897 -1 10.0005C-1 10.332 -0.868304 10.65 -0.633884 10.8844C-0.399463 11.1188 -0.0815206 11.2505 0.25 11.2505H10.25H10.3625L8.2125 14.3005C8.11658 14.4348 8.04822 14.5869 8.01137 14.7478C7.97453 14.9087 7.96991 15.0753 7.99781 15.238C8.0257 15.4007 8.08554 15.5563 8.17388 15.6957C8.26222 15.8352 8.37731 15.9558 8.5125 16.0505C8.725 16.1988 8.97835 16.2775 9.2375 16.2755C9.43581 16.2746 9.63106 16.2265 9.80712 16.1352C9.98317 16.0439 10.135 15.912 10.25 15.7505L13.775 10.7505C13.9314 10.5364 14.0157 10.2781 14.0157 10.013C14.0157 9.74785 13.9314 9.48957 13.775 9.27549L10 4.25049Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_48001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d02fc04c62aa1e3100a12d9eb70088be.svg";
export { ForwardRef as ReactComponent };